import { HttpClient } from '@angular/common/http';
import { InjectionToken, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject, filter } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { ApiVersion } from '../../models';

export abstract class BaseRepositoryService {
    protected http: HttpClient = inject(HttpClient);
    protected baseUrls: Subject<RepositoryBaseUrlConfig> = inject(REPOSITORY_BASE_URL_TOKEN);

    public constructor(private baseUrlKey: keyof RepositoryBaseUrlConfig) {}

    protected getApiUrl(resource: string, apiVersion: ApiVersion | null = 'v1'): Observable<string> {
        return this.baseUrls.pipe(
            tap((baseUrls) => {
                if (!baseUrls) {
                    console.debug('BaseRepositoryService: No base urls have been returned.');
                }
            }),
            filter(Boolean),
            map((baseUrls) => baseUrls[this.baseUrlKey]),
            tap((baseUrls) => {
                if (!baseUrls) {
                    console.debug(`BaseRepositoryService: The url for key '${this.baseUrlKey}' is not found.`);
                }
            }),
            filter(Boolean),
            take(1),
            map((baseUrl) => {
                const apiVersionStr = apiVersion ? `/${apiVersion}` : '';
                const resourceStr = resource.startsWith('/') ? resource : `/${resource}`;
                return `${baseUrl}${apiVersionStr}${resourceStr}`;
            })
        );
    }
}

export interface RepositoryBaseUrlConfig {
    userApi: string;
    tenantApi: string;
    taskApi: string;
    reportingApi: string;
    assetLinkApi: string;
    assetApi: string;
    formApi: string;
}

export const REPOSITORY_BASE_URL_TOKEN = new InjectionToken<Subject<RepositoryBaseUrlConfig | null>>(
    'REPOSITORY_BASE_URL_TOKEN'
);

export const RepositoryBaseUrlConfigFactory = () => new BehaviorSubject<RepositoryBaseUrlConfig | null>(null);
